(function($) {

	$.fn.hideMessage = function(options) {
		// build main options before element iteration
		var opts = $.extend( {}, $.fn.hideMessage.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend(true, eOpts, $this.dataset()) : eOpts;

            // Do the work here
            hideMessage();
        });
	};
	//
	// plugin defaults
	//
	$.fn.hideMessage.defaults = {
	};
    //
    // Private functions
    //
    function hideMessage(){

        $(".hide-me-message").filter(':visible').each(function(){
           var hidden = $(this);
           var speed = hidden.metadata()['speed'];
           if (typeof speed === 'undefined') {
               speed = 2000;
           }
           hidden.fadeTo(speed,1, function(){$(this).slideUp(200);});
        });
    }

})(jQuery);